import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppCta from "./components/WhatsAppCta";
import Navbar from "./sections/Navbar";
import Footer from "./sections/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SolutionsPage from "./pages/SolutionsPage";
import FaqsPage from "./pages/FaqsPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import AdminPage from "./admin/AdminPage";

const TOASTER_OPTIONS = {
  style: {
    background: "#0F172A",
    border: "1px solid rgba(0, 229, 255, 0.3)",
    color: "#F8FAFC",
    borderRadius: "0",
  },
};

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <WhatsAppCta />
    </>
  );
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  const routes = (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/solutions" element={<SolutionsPage />} />
      <Route path="/faqs" element={<FaqsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );

  return isAdmin ? routes : <PublicLayout>{routes}</PublicLayout>;
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" toastOptions={TOASTER_OPTIONS} />
    </div>
  );
}

export default App;
